import React, { useState, useEffect } from 'react';
import { MdDownload, MdReceipt } from 'react-icons/md';
import api from '../services/api';
import { getCurrentUser } from '../services/authService';
import ClientLayout from '../components/ClientLayout';

const BRAND = '#068BC9';

export default function ClientCompanyInvoices() {
  const user = getCurrentUser();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.companyId) return;
    api.get(`/api/company-invoices/company/${user.companyId}`)
      .then(res => setInvoices(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user?.companyId]);

  return (
    <ClientLayout>
      <div className="p-6 space-y-6">
        <div>
          <h1 className="text-xl font-bold text-gray-800">Invoices</h1>
          <p className="text-xs text-gray-400">Monthly invoices from ProDiligix</p>
        </div>
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="px-5 py-4 border-b border-gray-100">
            <p className="text-sm font-semibold text-gray-700">Invoice History ({invoices.length})</p>
          </div>
          {loading ? (
            <div className="p-8 text-center text-gray-400 text-sm">Loading...</div>
          ) : invoices.length === 0 ? (
            <div className="p-8 text-center">
              <MdReceipt size={36} className="text-gray-200 mx-auto mb-2" />
              <p className="text-sm text-gray-400">No invoices available yet</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-50">
                  <tr>{['Invoice No.','Date','Service','Description','Amount','Action'].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-medium text-gray-500">{h}</th>
                  ))}</tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {invoices.map(inv => (
                    <tr key={inv.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-xs font-medium whitespace-nowrap" style={{color:BRAND}}>{inv.invoiceNumber}</td>
                      <td className="px-4 py-3 text-xs text-gray-500 whitespace-nowrap">{inv.invoiceDate}</td>
                      <td className="px-4 py-3 text-xs text-gray-600 whitespace-nowrap">{inv.serviceType}</td>
                      <td className="px-4 py-3 text-xs text-gray-500">{inv.description||'—'}</td>
                      <td className="px-4 py-3 text-xs font-semibold text-gray-700 whitespace-nowrap">₹{parseFloat(inv.amount).toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
                      <td className="px-4 py-3 text-xs whitespace-nowrap">
                        {inv.filePath ? (
                          <a href={'https://api.prodiligix.com' + inv.filePath} target="_blank" rel="noreferrer"
                            className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-white text-xs font-medium w-fit"
                            style={{backgroundColor:BRAND}}>
                            <MdDownload size={14}/> Download
                          </a>
                        ) : <span className="text-gray-400 text-xs">No file</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </ClientLayout>
  );
}
